import * as types from '../mutation-types'
import PermissaoService from '@/domain/permissao/PermissaoService';
import Usuario from '@/domain/login/Usuario';
import Session from '@/domain/login/Session.js'
import config from '@/config/config.js'
import * as Cookies from 'js-cookie'
import {CognitoIdentityCredentials} from "aws-sdk/lib/core";
import CognitoIdentityServiceProvider from 'aws-sdk/clients/cognitoidentityserviceprovider';
import Vue from 'vue';

//estrutura inicial do usuario
const state = new Usuario()

const getters = {
    getUser: state => state,
    getUserToken: state => state.session,
    getUserIDToken: state => {isNotEmpty(state.session.idToken) ? state.session.idToken : ''},
    getUserInfoIsNotEmpty: state => {
       return Object.keys(state.session).length > 0 && Object.keys(state.permissoes).length > 0 && Object.keys(state.hash).length > 0
    },
    getUserPermission: state => state.permissoes,
    getUserPermissionShowMenu: (state) => (transition) => state.permissoes[transition.name] || transition.meta.ignore,
}

const actions = {
    saveUserToken({ commit }, cognito) {
        if (isNotEmpty(cognito)) {
            let session = new Session()
            session.idToken = cognito.idToken.jwtToken;
            session.accessToken = cognito.accessToken.jwtToken;
            session.refreshToken = cognito.refreshToken.token;
            session.grupoUsuario = cognito.accessToken.payload["cognito:groups"][0];
            
            commit(types.SET_INFO_SESSION, { session })
        }
    },
    saveUserPermissao ({ commit }) {
        return new Promise((callback, reject) => {
            if (this.state.usuario.session.idToken) {
                this.service = new PermissaoService();
                this.service.buscarPermissoes()
                .then(retorno => {
                    var permissoes = JSON.parse(JSON.stringify(retorno.data))
                    commit(types.SET_INFO_PERMISSOES, { permissoes })
                    callback(permissoes);
                })
                .catch((error) => {
                    reject(error);
                });
            }else{
                reject();
            }
        });
    },

    saveUserMenuFiltrado({ commit }, menu_filtrado) {
        if (menu_filtrado) {
            commit(types.SET_INFO_MENU_FILTRADO, { menu_filtrado })
        }
    },
  
    cleanInfoUser ({ commit }) {
        try{
            if(this.state.usuario.session.idToken && this.state.usuario.session.accessToken) {
                var paramsCredentials = {
                    IdentityPoolId: config.cognito.identityPoolId,
                    Logins: {},
                };
                var regiao = config.region
                
                //passing dynamically the user pool id along with some constants
                paramsCredentials.Logins[config.cognito.logins] = this.state.usuario.session.idToken;
                var credentials = new CognitoIdentityCredentials(paramsCredentials, {region: regiao});

                var cognitoidentityserviceprovider = new CognitoIdentityServiceProvider({region: regiao, credentials});
                var params = { AccessToken: this.state.usuario.session.accessToken};

                cognitoidentityserviceprovider.globalSignOut(params);

                Cookies.remove(config.cookie.cookieName);
                localStorage.clear()
                commit(types.SET_CLEAN_INFO_USER)
            }
        }catch(e){
            // console.log(e);
            Cookies.remove(config.cookie.cookieName);
            localStorage.clear()
            commit(types.SET_CLEAN_INFO_USER)
        }
    },

    saveHash({ commit }, hash) {
        commit(types.SET_HASH, { hash})
    }
}

const mutations = {
    [types.SET_INFO_SESSION] (state, { session }) {
        // Vue.set(state.session, 'idToken', session.idToken)
        // Vue.set(state.session, 'accessToken', session.accessToken)
        // Vue.set(state.session, 'refreshToken', session.refreshToken)
        // Vue.set(state.session, 'grupoUsuario', session.grupoUsuario)
        state.session = session;
    },
    [types.SET_INFO_PERMISSOES] (state, { permissoes }) {
        state.permissoes = permissoes
    },
    [types.SET_INFO_MENU_FILTRADO] (state, { menu_filtrado }) {
        state.menu_filtrado = menu_filtrado
    },
    [types.SET_CLEAN_INFO_USER] (state) {
        state.session = {}
        state.permissoes = {}
        state.menu_filtrado = {}
        state.hash = {}
   
    },
    [types.SET_HASH] (state, { hash }) {
        state.hash = hash
    }
  }

export default {
    state,
    getters,
    actions,
    mutations,
}

function isNotEmpty(object) {
    try {
        return Object.keys(object).length > 0
    } catch (error) {
        return false
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/usuario.js